import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { DialogTitle, FormLabel } from '@mui/material';
import { useLocalization, LoadingEvent } from '@ui-framework/index';
import ServiceProviderContact from './ServiceProviderContact';
import DialogCloseButton from '../../Dialogs/DialogCloseButton';
import IconLibrary from '../../IconLibrary';

function ChangeMainContactModal({
  open,
  serviceProviderId,
  setOpenModal,
  locationId,
  action = 'UPDATE',
  onChange = () => undefined,
}) {
  const { formatMessage } = useLocalization();

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(null);

  const buttons = [
    {
      children: formatMessage({
        id: 'SELECT_MAIN',
        defaultMessage: 'Select',
      }),
      type: 'submit',
      variant: 'contained',
      color: 'primary',
      disabled: !value || loading,
      startIcon: <IconLibrary.Yes />,
      onClick: async () => {
        setLoading(true);
        if (value?.value) {
          onChange(JSON.parse(value?.value));
        }
        setLoading(false);
        setOpenModal(false);
      },
    },
    {
      children: formatMessage({ id: 'CANCEL', defaultMessage: 'Cancel' }),
      onClick: () => setOpenModal(false),
      startIcon: <IconLibrary.Cancel />,
      variant: 'contained',
      color: 'secondary',
    },
  ];

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 400,
        bgcolor: 'background.paper',
      }}>
      <Dialog
        id="update-main-contact-modal"
        sx={{ '& .MuiDialog-paper': { width: '80%' } }}
        open={open}>
        {!loading && (
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconLibrary.User />
            <FormattedMessage
              id={
                action === 'NEW' ? 'SELECT_MAIN-CONTACT' : 'UPDATE_MAINCONTACT'
              }
              defaultMessage={
                action === 'NEW' ? 'Select Main Contact' : 'Change Main Contact'
              }
            />
            <DialogCloseButton
              disabled={loading}
              onClose={() => {
                setOpenModal(false);
              }}
            />
          </DialogTitle>
        )}
        {loading ? (
          <DialogContent>
            <LoadingEvent>
              <FormattedMessage
                id="LOADING_CONTACTS"
                defaultMessage="Loading Contacts..."
              />
            </LoadingEvent>
          </DialogContent>
        ) : (
          <Box>
            <DialogContent>
              <ServiceProviderContact
                name="updateMainContact"
                serviceProviderId={serviceProviderId}
                locationId={locationId}
                onChange={d => {
                  setValue(d);
                }}
              />
              <FormLabel sx={{ mt: 1 }}>
                <FormattedMessage
                  id="UPDATE_MAINCONTACT_DESCRIPTION"
                  defaultMessage="Only active users may be designated as a contact. If the individual you are seeking does not appear in the list, ensure they have been added as a user to the system."
                />
              </FormLabel>
            </DialogContent>
            {!loading ? (
              <DialogActions
                display="flex"
                sx={{ justifyContent: 'center', my: 2 }}>
                {buttons.map(btn => {
                  const { children, ...rest } = btn;
                  return (
                    <Button key={children} disabled={loading} {...rest}>
                      {children}
                    </Button>
                  );
                })}
              </DialogActions>
            ) : null}
          </Box>
        )}
      </Dialog>
    </Box>
  );
}

export default ChangeMainContactModal;
